import React from "react";
import './ReadOnlyInput.scss';

const ReadOnlyInput = ({name, type, value}) => {
  return (
    <input
      type={type}
      readOnly
      className={'outlined-input'}
      value={value}
      {...(name ? { name } : {})}
    />
  );
}

export default ReadOnlyInput;